import React, { createContext, useState, useEffect } from 'react';

export const GlobalContext = createContext(null);

export const GlobalProvider = ({ children }) => {
	const [globalActivationProxyPriv, setGlobalActivationProxyPriv] = useState(() => {
		// Retrieve initial state from local storage if available
		const savedState = localStorage.getItem('globalActivationProxyPriv');
		return savedState !== null ? JSON.parse(savedState) : null;
	});

	useEffect(() => {
		// Save state to local storage whenever it changes
		localStorage.setItem('globalActivationProxyPriv', JSON.stringify(globalActivationProxyPriv));
	}, [globalActivationProxyPriv]);

	const cleanUpGlobalActivationProxyPriv = () => {
		localStorage.removeItem('globalActivationProxyPriv');
	};

	return <GlobalContext.Provider value={{ globalActivationProxyPriv, setGlobalActivationProxyPriv, cleanUpGlobalActivationProxyPriv }}>{children}</GlobalContext.Provider>;
};
